import { render, staticRenderFns } from "./ReportInfoPage.vue?vue&type=template&id=93107b2c&"
import script from "./ReportInfoPage.vue?vue&type=script&lang=js&"
export * from "./ReportInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./ReportInfoPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports